export const ActionKeys = {
  RESET_IS_FETCHED: "CHAPTER_RESET_IS_FETCHED",
  RESET_ACTIVE_CHAPTER_BUDGET: "RESET_ACTIVE_CHAPTER_BUDGET",
  REQUEST_MEMBER_COUNTS: "CHAPTER_REQUEST_MEMBER_COUNTS",
  RECEIVE_MEMBER_COUNTS: "CHAPTER_RECEIVE_MEMBER_COUNTS",
  REQUEST_HELP_TEXT: "REQUEST_HELP_TEXT",
  RECEIVE_HELP_TEXT: "RECEIVE_HELP_TEXT",
  CREATE_MEMBER_COUNT: "CHAPTER_CREATE_MEMBER_COUNT",
  UPDATE_MEMBER_COUNT: "CHAPTER_UPDATE_MEMBER_COUNT",
  REQUEST_CHAPTER_FINANCIALS: "CHAPTER_REQUEST_CHAPTER_FINANCIALS",
  RECEIVE_CHAPTER_FINANCIALS: "CHAPTER_RECEIVE_CHAPTER_FINANCIALS",
  REQUEST_CHAPTER_FINANCIAL: "CHAPTER_REQUEST_CHAPTER_FINANCIAL",
  RECEIVE_CHAPTER_FINANCIAL: "CHAPTER_RECEIVE_CHAPTER_FINANCIAL",
  REQUEST_CHAPTER_BUDGETS: "CHAPTER_REQUEST_CHAPTER_BUDGETS",
  RECEIVE_CHAPTER_BUDGETS: "CHAPTER_RECEIVE_CHAPTER_BUDGETS",
  REQUEST_CHAPTER_BUDGET: "CHAPTER_REQUEST_CHAPTER_BUDGET",
  RECEIVE_CHAPTER_BUDGET: "CHAPTER_RECEIVE_CHAPTER_BUDGET",
  CREATE_CHAPTER_BUDGET_STARTED: "CHAPTER_CREATE_CHAPTER_BUDGET_STARTED",
  CREATE_CHAPTER_BUDGET_FINISHED: "CHAPTER_CREATE_CHAPTER_BUDGET_FINISHED",
  UPDATE_CHAPTER_BUDGET_STARTED: "CHAPTER_UPDATE_CHAPTER_BUDGET_STARTED",
  UPDATE_CHAPTER_BUDGET_FINISHED: "CHAPTER_UPDATE_CHAPTER_BUDGET_FINISHED",
  RECEIVE_CHAPTER_SUMMARY_REPORT: "RECEIVE_CHAPTER_SUMMARY_REPORT",
  REQUEST_CHAPTER_SUMMARY_REPORT: "REQUEST_CHAPTER_SUMMARY_REPORT",
  UPDATE_CHAPTER_BUDGET_FILE_STARTED:
    "CHAPTER_UPDATE_CHAPTER_BUDGET_FILE_STARTED",
  UPDATE_CHAPTER_BUDGET_FILE_FINISHED:
    "CHAPTER_UPDATE_CHAPTER_BUDGET_FILE_FINISHED",
  DOWNLOAD_CHAPTER_BUDGET_FILE_STARTED:
    "CHAPTER_DOWNLOAD_CHAPTER_BUDGET_FILE_STARTED",
  DOWNLOAD_CHAPTER_BUDGET_FILE_FINISHED:
    "CHAPTER_DOWNLOAD_CHAPTER_BUDGET_FILE_FINISHED",
  REQUEST_CHAPTER_FINANCIALS_DEFAULTS:
    "CHAPTER_REQUEST_CHAPTER_FINANCIALS_DEFAULTS",
  RECEIVE_CHAPTER_FINANCIALS_DEFAULTS:
    "CHAPTER_RECEIVE_CHAPTER_FINANCIALS_DEFAULTS",
  CREATE_REPORT_ADMIN_NOTES_FINISHED:
    "CHAPTER_CREATE_REPORT_ADMIN_NOTES_FINISHED",
  CREATE_REPORT_ITEM_STARTED: "CHAPTER_CREATE_REPORT_ITEM_STARTED",
  CREATE_REPORT_ITEM_FINISHED: "CHAPTER_CREATE_REPORT_ITEM_FINISHED",
  UPDATE_REPORT_ITEM_STARTED: "CHAPTER_UPDATE_REPORT_ITEM_STARTED",
  UPDATE_REPORT_ITEM_FINISHED: "CHAPTER_UPDATE_REPORT_ITEM_FINISHED",
  REMOVE_REPORT_ITEM_STARTED: "CHAPTER_REMOVE_REPORT_ITEM_STARTED",
  REMOVE_REPORT_ITEM_FINISHED: "CHAPTER_REMOVE_REPORT_ITEM_FINISHED",
  UPDATE_REPORT_ITEMS_STARTED: "CHAPTER_UPDATE_REPORT_ITEMS_STARTED",
  UPDATE_REPORT_ITEMS_FINISHED: "CHAPTER_UPDATE_REPORT_ITEMS_FINISHED",
  INITIAL_REPORT_ITEMS_STARTED: "CHAPTER_INITIAL_REPORT_ITEMS_STARTED",
  INITIAL_REPORT_ITEMS_FINISHED: "CHAPTER_INITIAL_REPORT_ITEMS_FINISHED",
  UPDATE_REPORT_W2_STARTED: "CHAPTER_UPDATE_REPORT_W2_STARTED",
  UPDATE_REPORT_W2_FINISHED: "CHAPTER_UPDATE_REPORT_W2_FINISHED",
  UPDATE_REPORT_VOTING_COUNT_STARTED:
    "CHAPTER_UPDATE_REPORT_VOTING_COUNT_STARTED",
  UPDATE_REPORT_VOTING_COUNT_FINISHED:
    "CHAPTER_UPDATE_REPORT_VOTING_COUNT_FINISHED",
  CREATE_FINANCIAL_ACCOUNT_STARTED: "CHAPTER_CREATE_FINANCIAL_ACCOUNT_STARTED",
  CREATE_FINANCIAL_ACCOUNT_FINISHED:
    "CHAPTER_CREATE_FINANCIAL_ACCOUNT_FINISHED",
  UPDATE_FINANCIAL_ACCOUNT_STARTED: "CHAPTER_UPDATE_FINANCIAL_ACCOUNT_STARTED",
  UPDATE_FINANCIAL_ACCOUNT_FINISHED:
    "CHAPTER_UPDATE_FINANCIAL_ACCOUNT_FINISHED",
  REMOVE_FINANCIAL_ACCOUNT_STARTED: "CHAPTER_REMOVE_FINANCIAL_ACCOUNT_STARTED",
  REMOVE_FINANCIAL_ACCOUNT_FINISHED:
    "CHAPTER_REMOVE_FINANCIAL_ACCOUNT_FINISHED",
  REQUEST_CHAPTER_FINANCIAL_BY_YEAR:
    "CHAPTER_REQUEST_CHAPTER_FINANCIAL_BY_YEAR",
  RECEIVE_CHAPTER_FINANCIAL_BY_YEAR:
    "CHAPTER_RECEIVE_CHAPTER_FINANCIAL_BY_YEAR",
  SUBMIT_CHAPTER_FINANCIAL_STARTED: "CHAPTER_SUBMIT_CHAPTER_FINANCIAL_STARTED",
  SUBMIT_CHAPTER_FINANCIAL_FINISHED:
    "CHAPTER_SUBMIT_CHAPTER_FINANCIAL_FINISHED",
  REQUEST_CHAPTER_ANALYSIS_REPORTS: "REQUEST_CHAPTER_ANALYSIS_REPORTS",
  RECEIVE_CHAPTER_ANALYSIS_REPORTS: "RECEIVE_CHAPTER_ANALYSIS_REPORTS"
};
